import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Button, Chip, Typography, IconButton, Collapse, Card, Tooltip } from '@mui/material';
import "./ExtensionCard.css"; // Import normal CSS
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ExtensionDialog from "../ExtensionDialog/ExtensionDialog";
import { Chat } from "@mui/icons-material";
import PublicIcon from '@mui/icons-material/Public';
import ExtensionIcon from '@mui/icons-material/Extension';

const ExtensionCard = ({ extension, onClick, onStartChat, onSectionChange, setSelectedSection, setNav, selectedExtension,
    onUpdateExtension,
    onRemoveExtension, featured }) => {


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 2,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                height: '180px',
                width: '100%',
                overflow: 'hidden', // Ensure content doesn't overflow
                position: 'relative',
                transition: 'transform 0.2s ease-in-out', // Smooth transition
                '&:hover': {
                    transform: 'scale(1.01)', // Slight zoom effect on hover
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)', // Optional shadow for a lifted effect
                    border: '1px solid rgb(146, 145, 145)',

                }
            }}
        >
            <Box sx={{ display: 'flex',position: 'relative' }}>
                {/* Avatar and Name */}
                <Avatar
                    src={extension?.imagePath || undefined}
                    sx={{
                        width: 50,
                        height: 50,
                        borderRadius: '50%',
                        marginRight: 2,
                        border: '2px solid #4527a0',
                        boxShadow: 2,
                    }}
                >
                    {!extension?.imagePath && <ExtensionIcon />}
                </Avatar>


                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex: 1,
                        position: 'relative',
                    }}
                >
                    {/* Extension Name */}
                    <Typography
                        variant="p"
                        sx={{
                            fontWeight: 600,
                            color: '#4527a0',
                            textAlign: 'left',
                            marginBottom: 1,
                            fontSize: '1.1rem',
                            lineHeight: '1.2',
                        }}
                    >
                        {extension.extensionName}
                    </Typography>

                    <Box
                        sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1, // Limits to one line before truncating
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "320px",
                            wordBreak: "break-word",
                            textAlign: 'left',
                        }}
                        title={extension?.tools?.join(', ')}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "break-word",
                            }}
                        >
                            {extension.tools.join(' | ')}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ textAlign: 'left' }} title={extension?.extensionDescription}>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2, // Limit to 2 lines
                        overflow: 'hidden',
                    }}
                >
                    {extension.extensionDescription}
                </Typography>
            </Box>

            <ExtensionDialog
                extension={extension}
                onStartChat={onStartChat}
                onUpdateExtension={onUpdateExtension}
                onRemoveExtension={onRemoveExtension}
                featured={featured}
            />

            {/* Start Chat Button */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
                {/* {featured &&
                    <PublicIcon sx={{
                        position: "absolute",
                        bottom: 4,
                        left: 10,
                    }} />
                } */}


                <Button
                    onClick={(e) => {
                        e.stopPropagation();
                        onStartChat(extension);
                        setSelectedSection("chats");
                    }}
                    size="small"
                    variant="outlined"
                    sx={{
                        color: "#99cc33",
                        border: "1px solid #99cc33",
                        fontSize: "0.8rem",
                        padding: "4px 8px",
                        textTransform: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        "&:hover": {
                            backgroundColor: "rgba(153, 204, 51, 0.1)",
                        },
                        position: "absolute",
                        bottom: 3,
                        right: 4,

                    }}
                >
                    <Chat fontSize="small" />
                    Start Chat
                </Button>


            </Box>
        </Box>
    );
};

ExtensionCard.propTypes = {
    extension: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    onStartChat: PropTypes.func.isRequired,
};

export default ExtensionCard;